import { render, staticRenderFns } from "./RawMaterialSupplierAdd.vue?vue&type=template&id=52a28100&scoped=true"
import script from "./RawMaterialSupplierAdd.vue?vue&type=script&lang=js"
export * from "./RawMaterialSupplierAdd.vue?vue&type=script&lang=js"
import style0 from "./RawMaterialSupplierAdd.vue?vue&type=style&index=0&id=52a28100&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a28100",
  null
  
)

export default component.exports